import React, { useEffect, useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutlined";
import "./ImpactProgress.css";
import { STEPS } from "../../../conts/simulationConstants";
import { MAX_PROGRESS, STEP_MS } from "../../../conts/constants";

const ImpactProgress = () => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => setElapsed(Date.now() - start), 150);
    return () => clearInterval(id);
  }, []);

  const current = Math.min(Math.floor(elapsed / STEP_MS), STEPS.length - 1);
  // eases toward MAX_PROGRESS: fast at first, slower after
  const progress = MAX_PROGRESS * (1 - Math.exp(-elapsed / 4000));

  return (
    <div className="impact-progress" role="status" aria-live="polite">
      <div
        className="impact-progress__track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(progress)}
      >
        <div
          className="impact-progress__fill"
          style={{ width: `${progress}%` }}
        />
      </div>

      <ul className="impact-progress__steps">
        {STEPS.map((label, i) => {
          if (i > current) return null; // messages appear one after another
          const done = i < current;
          return (
            <li
              key={label}
              className={`impact-progress__step ${done ? "is-done" : "is-active"}`}
            >
              {done ? (
                <CheckCircleOutlineIcon fontSize="small" />
              ) : (
                <span className="impact-progress__spinner" />
              )}
              {label}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ImpactProgress;
